import type { Schema } from '@wix/wix-data-schema-types'
import {
  CATALOG_PLUGIN_ID,
  CATEGORIES_PLUGIN_ID,
  SINGLES_PLUGIN_ID,
} from '@wix/wix-data-schema-types'
import type {
  ActionDefinition,
  PluginType,
} from '@wix/data-binding-tpa-actions'

export const collectionTypes = {
  MULTI_ITEM_COLLECTION: 'MULTI_ITEM_COLLECTION',
  SINGLE_ITEM_COLLECTION: 'SINGLE_ITEM_COLLECTION',
}

export const getCollectionTypeFromSchema = ({ plugins }: Schema) => {
  return plugins?.[SINGLES_PLUGIN_ID] !== undefined
    ? collectionTypes.SINGLE_ITEM_COLLECTION
    : collectionTypes.MULTI_ITEM_COLLECTION
}

export const isSinglesCollectionSchema = (schema: Schema) =>
  getCollectionTypeFromSchema(schema) === collectionTypes.SINGLE_ITEM_COLLECTION

export const isMultiItemCollectionSchema = (schema: Schema) =>
  getCollectionTypeFromSchema(schema) === collectionTypes.MULTI_ITEM_COLLECTION

export const isCatalogCollectionSchema = ({ plugins }: Schema) =>
  plugins?.[CATALOG_PLUGIN_ID] !== undefined

export const isCategoryCollection = (collection: Schema | undefined): boolean =>
  !!collection?.plugins?.[CATEGORIES_PLUGIN_ID]

// Action matching utilities
export const matchesPluginType = (
  pluginType: PluginType,
  collection: Schema,
): boolean => {
  if (pluginType === 'CATALOG') {
    return isCatalogCollectionSchema(collection)
  }
  return false
}

export const matchesCollection = (
  action: ActionDefinition<string>,
  collection: Schema,
): boolean => {
  if (action.type === 'pluginType') {
    return matchesPluginType(action.pluginType, collection)
  }
  if (action.type === 'collection') {
    return collection.id === action.collectionId
  }
  // Global actions (no type) match all collections
  return true
}
